import { useIntlayer } from 'react-intlayer';

import { JadePlatformSection } from './JadePlatformSection';

import { ProductCTASection } from '~/components/ui/ProductCTASection';
import { ProductHeroSection } from '~/components/ui/ProductHeroSection';
import { ProductMainPhraseSection } from '~/components/ui/ProductMainPhraseSection';
import { ProductOverviewSection } from '~/components/ui/ProductOverviewSection';


export const JadePageContent = () => {
  const { hero, mainPhrase, overview, platform, cta } = useIntlayer('jade');

  const services = [
    {
      title: platform.services.s01.title,
      description: platform.services.s01.description,
      image: '/assets/images/jade1.jpg',
      accordionItems: [
        platform.services.s01.accordion.a01,
        platform.services.s01.accordion.a02,
        platform.services.s01.accordion.a03,
        platform.services.s01.accordion.a04,
      ],
    },
    {
      title: platform.services.s02.title,
      description: platform.services.s02.description,
      image: '/assets/images/jade2.jpg',
      accordionItems: [
        platform.services.s02.accordion.a01,
        platform.services.s02.accordion.a02,
        platform.services.s02.accordion.a03,
      ],
    },
    {
      title: platform.services.s03.title,
      description: platform.services.s03.description,
      image: '/assets/images/jade3.jpg',
      accordionItems: [
        platform.services.s03.accordion.a01,
        platform.services.s03.accordion.a02,
        platform.services.s03.accordion.a03,
      ],
    },
    {
      title: platform.services.s04.title,
      description: platform.services.s04.description,
      image: '/assets/images/jade4.jpg',
      accordionItems: [
        platform.services.s04.accordion.a01,
        platform.services.s04.accordion.a02,
      ],
    },
  ];

  return (
    <div className="bg-black min-h-full w-full">
      <ProductHeroSection
        subtitle={hero.subtitle}
        title={hero.title}
        videoSrc="/assets/video/hls/jade_new/master.m3u8"
        fallbackVideoSrc="/assets/video/jade_new.mp4"
        poster="/assets/images/jade_new_frame.png"
        titleClassName="md:text-[36px] md:tracking-[0.36px]"
      />
      <ProductMainPhraseSection text={mainPhrase.lines.line1.value} />
      <section className="relative w-full h-[560px] md:h-[945px]">
        <img
          src="/assets/images/jade_main.jpg"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
      </section>
      <ProductOverviewSection
        title={overview.title}
        description={overview.description}
        sectionClassName="bg-[#283541] px-4 md:px-20 py-[60px] md:py-[100px]"
        contentClassName="max-w-[760px]"
        descriptionClassName="text-[24px] md:text-[30px]"
      />
      <JadePlatformSection
        eyebrow={platform.eyebrow}
        headingLines={[platform.headingLines.line1, platform.headingLines.line2]}
        services={services}
      />
      <ProductCTASection
        title={cta.title}
        heading={hero.title}
        button1Text={cta.button1}
        backgroundImage="/assets/images/jade_cta.jpg"
      />
    </div>
  );
};
